module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAY0lEQVQYV3XKsQnCYBSF0XPBBezVIUSnsE/jFFnE3gWcwBnsBSs7h7ATXvhDCpF4u+9yUlUdVub3SVW9sPkDNLDHDYsZdE47q6rH6Qc8sBvBhK44TPnGNsnzGyxxxxrHJJeGB0ZmHQesT5BCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/bottomArrow.png
// module id = nqU3
// module chunks = 2